import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types'
import { actionCreators } from 'reduxBits/adBlocker'

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
})

export class _AdBlockDetector extends React.Component {
  componentDidMount() {
    this.props.actions.detectAdBlocker()
  }

  render() {
    return null
  }
}

_AdBlockDetector.propTypes = {
  actions: PropTypes.object.isRequired,
}

export default connect(null, mapDispatchToProps)(_AdBlockDetector)
